import * as React from 'react';
import { observer } from 'mobx-react';
import WithAuthentication from './Login/WithAuthentication';
import PageLayoutWrapper from './PageLayoutWrapper';

interface Props {
  children?: React.ReactNode;
}

const PageLayoutWithAuthenticationWrapper: React.FC<Props> = ({ children }) => {
  return (
    <PageLayoutWrapper>
      <WithAuthentication>{children}</WithAuthentication>
    </PageLayoutWrapper>
  );
};

export default observer(PageLayoutWithAuthenticationWrapper);
